import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import { RetailerVendorSettingsSendMethod } from "../../../api";

export interface SendMethodListProps {
  value?: RetailerVendorSettingsSendMethod;
  onChange?: (value: RetailerVendorSettingsSendMethod) => void;
};

export const SendMethodList = (props: SendMethodListProps) => {
  const { value, onChange } = props;

  const handleChange = (value: string) => {
    if (onChange) onChange(value as RetailerVendorSettingsSendMethod);
  };

  return (
    <FormControl sx={{ minWidth: 200 }}>
      <InputLabel id="send-method-list-label">Send method</InputLabel>
      <Select labelId="send-method-list-label" label="Send method" value={value || RetailerVendorSettingsSendMethod.None} onChange={(e) => handleChange(e.target.value)}>
        {Object.keys(RetailerVendorSettingsSendMethod).map((item) => {
          return (
            <MenuItem value={item} key={item}>
              {item}
            </MenuItem>
          );
        })}
      </Select>
    </FormControl>
  );
};
